// Models
import { I_Position } from "../Models/interfaces";
// Models

export const baseUrl = "https://api.amoozeshmelli.com/api";
// export const baseUrl = "http://localhost:8000/api";

export const urlRegex = /https?:\/\/\S+/;
export const urlRegex2 = /\b\w+\.\w+\b/g;

export const numberPositionsForLargeScreen: I_Position[] = [
  {
    top: "10%",
    left: "15vw",
    zIndex: "20",
  },
  {
    top: "20%",
    right: "55vw",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "35vw",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "51vw",
    zIndex: "20",
  },
  {
    top: "90%",
    right: "6vw",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "45%",
    right: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    right: "60vw",
    zIndex: "20",
  },
  {
    top: "35%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "75%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "55%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "36vw",
    zIndex: "20",
  },
  {
    top: "53%",
    right: "20vw",
    zIndex: "20",
  },
  {
    top: "29%",
    left: "4vw",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "80vw",
    zIndex: "20",
  },
  {
    top: "10%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "70vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "90rem",
    zIndex: "20",
  },
  {
    top: "90%",
    right: "30rem",
    zIndex: "20",
  },
  {
    top: "80%",
    left: "66rem",
    zIndex: "20",
  },
  {
    top: "16%",
    left: "20vw",
    zIndex: "20",
  },
  {
    top: "39%",
    left: "50vw",
    zIndex: "20",
  },
  {
    top: "10%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "13%",
    left: "40vw",
    zIndex: "20",
  },
];

export const numberPositionsForSmallScreen: I_Position[] = [
  {
    top: "60%",
    left: "5rem",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "5rem",
    zIndex: "20",
  },
  {
    top: "30%",
    left: "5rem",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "5rem",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "30vw",
    zIndex: "20",
  },
  {
    top: "30%",
    right: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "70%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "60%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10rem",
    zIndex: "20",
  },
  {
    top: "40%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10rem",
    zIndex: "20",
  },
  {
    top: "60%",
    right: "10rem",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "6rem",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "30vw",
    zIndex: "20",
  },
  {
    top: "50%",
    left: "10vw",
    zIndex: "20",
  },
  {
    top: "40%",
    left: "10rem",
    zIndex: "20",
  },
];
